import {
    TAB,
    SET_IPFROM,
    SET_VIDEO
} from '../types'

let state = {
    tab: 0,
    isChina: false,
    isViewVideo: false
}

const mutations = {
    [TAB](state, tab) {
        state.tab = tab;
    },
    [SET_IPFROM](state, data) {
        state.isChina = data;
    },
    [SET_VIDEO](state, data) {
        state.isViewVideo = data;
    },
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base.js